import { useTranslation } from 'react-i18next';

function useCheckEng() {
    const { i18n } = useTranslation();
    if (i18n.language === 'en') return true;
    return false;
}

export default useCheckEng;
